import React, { useContext, useEffect, useRef, useState } from "react";
import { faSignOutAlt, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AuthContext } from "../context/AuthContext";

const initialsFor = (email = "") => {
  const local = email.split("@")[0] || "";
  const parts = local.split(/[._-]/).filter(Boolean);
  const letters =
    parts.length >= 2 ? parts[0][0] + parts[1][0] : local.slice(0, 2);
  return letters.toUpperCase() || "U";
};

const AvatarDropdown = () => {
  const node = useRef();
  const [open, setOpen] = useState(false);
  const { logout, authState } = useContext(AuthContext);
  const email = authState.userInfo?.email ?? "";
  const initials = initialsFor(email);

  useEffect(() => {
    const onClick = (e) => {
      if (node.current && !node.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div ref={node} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 rounded-full pl-1 pr-3 py-1 border border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition focus:outline-none"
      >
        <span className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-xs font-bold">
          {initials}
        </span>
        <span
          className="hidden sm:inline text-sm font-medium text-gray-700 truncate"
          style={{ maxWidth: 160 }}
        >
          {email}
        </span>
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-64 rounded-xl bg-white shadow-xl border border-gray-100 overflow-hidden z-20">
          <div className="px-4 py-3 border-b border-gray-100 flex items-center gap-3">
            <span className="w-9 h-9 rounded-full bg-primary text-white flex items-center justify-center text-sm font-bold">
              {initials}
            </span>
            <div className="min-w-0">
              <div className="text-xs text-gray-500 flex items-center gap-1">
                <FontAwesomeIcon icon={faUser} className="w-3" />
                Signed in as
              </div>
              <div className="text-sm font-semibold text-gray-900 truncate">
                {email}
              </div>
            </div>
          </div>
          <button
            type="button"
            onClick={() => logout({ returnTo: window.location.origin })}
            className="w-full px-4 py-3 flex items-center gap-3 text-sm text-gray-700 hover:bg-gray-50 transition"
          >
            <FontAwesomeIcon icon={faSignOutAlt} className="text-gray-400" />
            Log out
          </button>
        </div>
      )}
    </div>
  );
};

export default AvatarDropdown;
